<app-impersonation-banner></app-impersonation-banner>
@if (!isMaintenancePage()) {
  <app-header></app-header>
}
<main class="flex-grow-1" [class.user-app]="!isStaffPage()" [class.staff-app]="isStaffPage()">
  <router-outlet></router-outlet>
</main>
@if (!isMaintenancePage()) {
  <app-footer></app-footer>
}
